module.exports = __webpack_public_path__ + "static/media/challengechannel_sm.7e415628.jpg";